import { themeObject } from 'lib';
import * as yup from 'yup';

export interface ImportGlossaryMetadataFormInputs {
    fileType: string;
}

export const ImportGlossaryMetadataSchema = yup.object({
    fileType: yup.string().required(),
});

export const importGlossaryMetadataDefaults = {
    fileType: 'JSON',
};

export const importGlossaryStyles = {
    subHeadingTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        textAlign: 'center',
        color: themeObject.palette.grayScale[800],
    },
    gridStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mx: '143.5px',
        mt: 3,
    },
    containerStyles: {
        width: '100%',
        mt: 2,
    },
    subHeadingTextContainer: {
        mt: 1.5,
    },
};
